import * as React from "react";

import { cn } from "../../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | null;
}

export interface SpanProps extends React.InputHTMLAttributes<HTMLSpanElement> {
  error?: string | null;
}

const InputError = React.forwardRef<HTMLSpanElement, SpanProps>(
  ({ error, ...props }) => {
    return (
      <span className="text-sm font-medium text-red-500 w-full" {...props}>
        {error}
      </span>
    );
  },
);

InputError.displayName = "InputError";

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <>
        <input
          type={type}
          className={cn(
            "flex mb-1 h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className,
          )}
          ref={ref}
          {...props}
        />
        {error && <InputError error={error} />}
      </>
    );
  },
);
Input.displayName = "Input";

export { Input, InputError };
